/* RVIVL Starter — minimal progressive enhancement.
   Add-to-cart works without JS via the native variant <select>.
   This only mirrors the selected variant's price into the main price
   display for a slightly nicer experience. */

(function () {
  var select = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-price]');
  if (!select || !priceEl) return;

  select.addEventListener('change', function () {
    var option = select.options[select.selectedIndex];
    var price = option && option.getAttribute('data-price');
    if (price) priceEl.textContent = price;
  });
})();
